// extracted by mini-css-extract-plugin
export var adv = "style-module--adv--2996a";
export var container = "style-module--container--7819c";
export var title = "style-module--title--c4366";